import $ from 'jquery';

const mobileNavPrimaryLinksInit = () => {
    const $mobileNav = $('.mobile-nav');
    const $subMenus = $('#c-primary-links ul');
    const $parentLinks = $('a.parent-link');
    const $backLinks = $('a.back');
    const hasSubMenuClass = 'has-submenu';
    const subMenuActiveClass = 'submenu-active';
    const hasActiveSubMenuClass = 'has-active-submenu';

    // Give a class to every link with a submenu, so we can style it.
    $subMenus.each(function () {
        $(this).prev().addClass(hasSubMenuClass);
    });

    $('#c-primary-links button.has-submenu').on('click', function (e) {
        e.preventDefault();
        $(this).next('ul').addClass(subMenuActiveClass);
        $mobileNav.addClass(hasActiveSubMenuClass);

        // move the mask 'forward'
        $('#c-primary-links').css('transform', `translateX(-${100 * $('.submenu-active').length}%`);
    });

    $parentLinks.on('focusout', function () {
        // tabbed to the end of the line, go back to the top
        $(this).parent().parent()
            .find('.back')
            .focus();
    });

    $backLinks.on('click', function (e) {
        e.preventDefault();
        $(this).parent().parent().removeClass(subMenuActiveClass);

        if ($('.submenu-active').length === 0) {
            $mobileNav.removeClass(hasActiveSubMenuClass);
        }

        // move the mask back.
        $('#c-primary-links').css('transform', `translateX(-${100 * $('.submenu-active').length}%`);
    });
};

// doc ready
$(() => {
    mobileNavPrimaryLinksInit();
});
